module.exports = __webpack_public_path__ + "static/media/logo-raoul-beaulieu.9d551d02.png";